import { useState } from "react";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

import { CheckedCheckboxIcon, UncheckedCheckboxIcon } from "./icons";

interface CheckboxProps extends React.ComponentProps<"input"> {
  className?: string;
  labelClassName?: string;
}

export default function Checkbox({
  children,
  className,
  labelClassName,
  ...props
}: CheckboxProps) {
  const [isChecked, setIsChecked] = useState(
    props.defaultChecked ?? props.checked ?? false
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(e.target.checked);
    props.onChange?.(e);
  };

  return (
    <Label>
      <Input
        {...props}
        className="hidden"
        onChange={handleChange}
        type="checkbox"
      />
      <span
        className={cn(
          "flex w-full items-center justify-between md:flex-row-reverse md:justify-end",
          className
        )}
      >
        <span className={cn("text-14/[1.2em]", labelClassName)}>
          {children}
        </span>
        <span className="relative flex md:mr-2">
          <UncheckedCheckboxIcon
            className={cn("transition-opacity", isChecked && "opacity-0")}
          />
          <CheckedCheckboxIcon
            className={cn(
              "absolute top-0 left-0 transition-opacity",
              !isChecked && "opacity-0"
            )}
          />
        </span>
      </span>
    </Label>
  );
}
